import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogContainer, Divider, FontIcon } from 'react-md';
import { injectIntl, intlShape } from 'react-intl';
import FieldGroup from '../FieldGroup';
import LoaderButton from '../LoaderButton';
import ErrorDisplay from '../ErrorDisplay';


export default injectIntl(class ContestDialog extends PureComponent {
  static propTypes = {
    intl: intlShape.isRequired,
    segment: PropTypes.oneOfType([
      PropTypes.shape({
        search: PropTypes.string,
      }).isRequired,
      PropTypes.array,
    ]),
    onClickReportError: PropTypes.func.isRequired,
    onClickRejectError: PropTypes.func,
    userAttributes: PropTypes.shape({
      isPsy: PropTypes.bool.isRequired,
    }).isRequired,
    style: PropTypes.object,
  }

  state = {
    visible: false,
    error: undefined,
    errorType: '',
    errorReason: '',
    isLoading: false,
  };

  clickOnReportError = () => {
    const { onClickReportError, segment, userAttributes: { isPsy } } = this.props;
    if (isPsy) {
      onClickReportError(segment);
    } else {
      this.show();
    }
  }

  clickOnRejectError = () => {
    const { onClickRejectError, segment, userAttributes: { isPsy } } = this.props;
    if (isPsy) {
      onClickRejectError(segment);
    }
  }

  show = () => {
    this.setState({ visible: true });
  };

  hide = () => {
    this.setState({ visible: false });
  };

  validateForm = () => this.state.errorType !== '' && this.state.errorReason.trim().length > 0;

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      error: undefined,
    });
  };

  handleOnForValidationClick = () => {
    const { onClickReportError, segment } = this.props;
    const { errorType, errorReason } = this.state;
    onClickReportError(segment, errorType, errorReason);
    this.hide();
  }

  render() {
    const { intl, style = {}, userAttributes: { isPsy } } = this.props;
    const { visible, error } = this.state;
    // Actions can either be an object of props to build a Button,
    // or valid react components. When the action is a set of props,
    // it defaults to creating a flat button. Unique keys will automatically
    // be cloned into the buttons along with an additional class name for styling

    const actions = [];
    actions.push({ secondary: true, children: intl.formatMessage({ id: 'contestDialog.retour' }), onClick: this.hide });
    actions.push(<LoaderButton
      flat
      primary
      disabled={!this.validateForm()}
      swapTheming
      text={intl.formatMessage({ id: 'contestDialog.forValidation' })}
      loadingText={intl.formatMessage({ id: 'contestDialog.forValidation' })}
      onClick={this.handleOnForValidationClick}
      isLoading={this.state.isLoading}
    />);

    return (
      <React.Fragment>
        {isPsy ? (
          <React.Fragment>
            <li>
              <Button
                flat
                onClick={this.clickOnRejectError}
                iconEl={<FontIcon>close</FontIcon>}
                style={style}
                className="md-cell--right"
              >
                {intl.formatMessage({ id: 'journeyDetails.rejectError' })}
              </Button>
            </li>
            <li>
              <Button
                flat
                onClick={this.clickOnReportError}
                iconEl={<FontIcon secondary>done</FontIcon>}
                style={style}
                className="md-cell--right"
              >
                {intl.formatMessage({ id: 'journeyDetails.acceptError' })}
              </Button>
            </li>
          </React.Fragment>) :
          <Button
            flat
            onClick={this.clickOnReportError}
            iconEl={<FontIcon>priority_hight</FontIcon>}
            style={style}
            className="md-cell--right"
          >
            {intl.formatMessage({ id: 'journeyDetails.reportError' })}
          </Button>}
        {visible &&
          <DialogContainer
            id="simple-action-dialog"
            visible={visible}
            onHide={this.hide}
            actions={actions}
            width={800}
            title={intl.formatMessage({ id: 'contestDialog.title' })}
          >
            <Divider />
            <ErrorDisplay error={error} />
            <FieldGroup
              id="errorType"
              autoFocus
              placeholder={intl.formatMessage({ id: 'contestDialog.selectErrorType' })}
              componentClass="select"
              value={this.state.errorType}
              onChange={this.handleChange}
              label={intl.formatMessage({ id: 'contestDialog.errorType' })}
            >
              <option value="">{intl.formatMessage({ id: 'contestDialog.selectErrorType' })}</option>
              <option value="MAPMATCHING">{intl.formatMessage({ id: 'contestDialog.errorTypes.mapmatching' })}</option>
              <option value="CARTOGRAPHY">{intl.formatMessage({ id: 'contestDialog.errorTypes.cartography' })}</option>
              <option value="SPEEDLIMIT">{intl.formatMessage({ id: 'contestDialog.errorTypes.speedlimit' })}</option>
              <option value="OTHER">{intl.formatMessage({ id: 'contestDialog.errorTypes.other' })}</option>
            </FieldGroup>
            <FieldGroup
              id="errorReason"
              componentClass="textarea"
              type="text"
              value={this.state.errorReason}
              onChange={this.handleChange}
              label={intl.formatMessage({ id: 'contestDialog.reason' })}
              rows={4}
            />
          </DialogContainer>
      }
      </React.Fragment>
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/Journey/ContestDialog.js